import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import '../../css/addproperty.css';
import '../../css/addroomdetails.css';
import '../../css/styles.css';
import chennaipincode from '../../assets/pincode.json';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";
import Dashboard from './Dashboard';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import builderjson from '../../assets/builders.json';
import Select from "react-select";


const customIcon = new L.Icon({
    iconUrl: markerIconPng,
    shadowUrl: markerShadowPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});

const LocationSelector = ({ setPosition, setAddress }) => {
    useMapEvents({
        click: async (e) => {
            const { lat, lng } = e.latlng;
            setPosition([lat, lng]);

            try {
                const response = await fetch(
                    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
                );
                const data = await response.json();
                if (data.display_name) {
                    setAddress(data.display_name);
                } else {
                    setAddress("Address not found");
                }
            } catch (error) {
                console.error("Error fetching address:", error);
            }
        }
    });
    return null;
};


const steps = [
    { id: 1, label: "Property Details" },
    { id: 2, label: "Address" },
    { id: 3, label: "Submit" },

];

export const NewProject = ({ agent_id, agent_name }) => {

    const pincodeData = chennaipincode;
    const [currentStep, setCurrentStep] = useState(1);
    const [step, setStep] = useState(1);

    const [propertyType, setPropertyType] = useState("Residential");
    // const [lookingTo, setLookingTo] = useState("Resale");
    // const [propertyDescription, setPropertyDescription] = useState("");
	  const [url, setUrl] = useState("");
 
    const [city, setCity] = useState("");
    const [building, setBuilding] = useState("");
    const [description, setDescription] = useState("");
    const [propertyType1, setPropertyType1] = useState("Apartment");
    const [SelectedBuilder, setSelectedBuilder] = useState('');
    const [builders, setBuilders] = useState([]);
    const [SelectedStatus, setSelectedStatus] = useState('');
    const [bhkTypes, setBhkTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [selectedPincode, setSelectedPincode] = useState('');
    const [localities, setLocalities] = useState([]);
    const [selectedLocality, setSelectedLocality] = useState('');
    const [minprice, setMinprice] = useState("");
    const [maxprice, setMaxprice] = useState("");
    const [projectsize, setProjectSize] = useState("");
    const [minUnitSize, setMinUnitSize] = useState("");
    const [maxUnitSize, setMaxUnitSize] = useState("");
    const [pricePerSqFt, setPricePerSqFt] = useState("");
    const [reraNumber, setReraNumber] = useState("");
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [features, setFeatures] = useState([]);
    const [locationAdvantages, setLocationAdvantages] = useState([]);
    const [carpetArea, setCarpetArea] = useState("");
    const [Address, setAddress] = useState("");
    const [locality, setLocality] = useState(""); // Default locality
    const [position, setPosition] = useState([12.9784, 80.2184]); // Default Lat/Lng for Velachery
    const [paraaddress, setParaAddress] = useState("");
    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [errors, setErrors] = useState({ propertyType: '', lookingTo: '' });


    const [vouchers, setVouchers] = useState([]);
    const [builtUpArea, setBuiltUpArea] = useState("");
    const [totalFloors, setTotalFloors] = useState("");
    const [BuildingDetails, setBuildingDetails] = useState("");



    useEffect(() => {

        const fetchBuilders = async () => {
            const data = builderjson;
            setBuilders(data);
        };

        fetchBuilders();
    }, []);
    const statusOptions = [
        { value: "New Launch", label: "New Launch" },
        { value: "Under Construction", label: "Under Construction" },
        { value: "Ready To Move", label: "Ready to Move" }
    ];

    const builderOptions = builders.map((builder) => ({
        label: builder.name,
        value: builder.name,
    }));
    const localityOptions = localities.map((loc) => ({
        value: loc,
        label: loc,
    }));


    useEffect(() => {
        return () => {
            // Cleanup on unmount
            images.forEach(image => {
                if (image instanceof File) {
                    URL.revokeObjectURL(image);
                }
            });
        };
    }, [images]);


    const handleVoucherUpload = (event) => {
        const files = Array.from(event.target.files);
        setVouchers((prevVouchers) => [...prevVouchers, ...files]);
    };

    const removeVoucher = (index) => {
        setVouchers((prevVouchers) => prevVouchers.filter((_, i) => i !== index));
    };
    const handleNextStep = () => {

        if (building.trim() !== "" && selectedLocality.trim() !== "") {
            return true;
        } else {
            return false;
        }
    };

    const handleNext = () => {
        if (currentStep < steps.length) {
            setCurrentStep(prev => prev + 1);
        }
        return true;
    }

    const handlePrevStep = () => {
        if (currentStep > 1) {
            setCurrentStep((prev) => prev - 1);
        }
    };

    const removeImage = (index) => {
        setImages((prev) => prev.filter((_, i) => i !== index));
    };

    const handleImageUpload = (event) => {
        const files = Array.from(event.target.files);
        setImages((prevImages) => [
            ...prevImages,
            ...files,
        ]);
    };

    const handleVideoUpload = (event) => {
        const files = Array.from(event.target.files);
        setVideos([...videos, ...files]);
    };

    const [floorPlans, setFloorPlans] = useState([
        { image: '', unitType: '1BHK', unitSize: '', toilet: '', carpetArea: '' }
    ]);

    const handleChange1 = (index, field, value) => {
        const updatedPlans = [...floorPlans];
        updatedPlans[index][field] = value;
        setFloorPlans(updatedPlans);
    };

    const addFloor = () => {
        setFloorPlans([
            ...floorPlans,
            { image: '', unitType: '1BHK', unitSize: '', toilet: '', carpetArea: '' }
        ]);
    };

  useEffect(() => {
        if (!url.trim()) return;

        const extractLatLngFromEmbedUrl = () => {
            // Tries both modern & alternate embed formats
            const latMatch = url.match(/!3d(-?\d+\.?\d*)/) || url.match(/@(-?\d+\.?\d*),/);
            const lngMatch = url.match(/!2d(-?\d+\.?\d*)/) || url.match(/@-?\d+\.?\d*,(-?\d+\.?\d*)/);

            if (latMatch && lngMatch) {
                const lat = parseFloat(latMatch[1]);
                const lng = parseFloat(lngMatch[1]);

                setPosition([lat, lng]);
                setAddress(`Lat: ${lat}, Lon: ${lng}`);
            } else {
                setPosition(null);
                setAddress("Invalid embed URL. Could not extract latitude/longitude.");
            }
        };

        extractLatLngFromEmbedUrl();
    }, [url]);



    const wrapperRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Filter pincode suggestions based on the search term
    const filteredPincodes = pincodeData.filter(item =>
        item.pincode.includes(searchTerm)
    );

    // Handle changes in the pincode input field
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setShowSuggestions(true);
        if (!value) {
            setShowSuggestions(false);
        }
        if (value.length === 6) {
            setErrors({ ...errors, pincode: "" });
        }
    };

    // Handle selecting a pincode from suggestions
    const handleSelect = (pincode) => {
        setSelectedPincode(pincode);
        const selected = pincodeData.find(item => item.pincode === pincode);
        setLocalities(selected ? selected.locality : []);
        setShowSuggestions(false);
        setErrors({ ...errors, pincode: '' });
    };

    // Handle selecting a locality
    const handleLocalityChange = (event) => {
        setSelectedLocality(event.target.value);
        setErrors({ ...errors, selectedLocality: '' });
    };

    const Amenites = [

        "street lights",
        "Rain Water Harvesting",
        "Lift",
        "CCTV",
        "Gym",
        "Garden",
        "Kids Area",
        "Sports",
        "Swimming Pool",
        "Intercom",
        "Gated Community",
        "Club House",
        "Community Hall",
        "Regular Water Supply",
        "Power Backup",
        "Pet Allowed",
        "MiniTheater",
        "Mini Party Hall",
        "Indoor games",
        "Multipurpose Hall"
    ];
    const propertyTypes = [
        "Apartment",
        "Villa",
        "Plot",
    ];
    const bhkOptions = [
        "1 RK",
        "1 BHK",
        "1.5 BHK",
        "2 BHK",
        "2.5 BHK",
        "3 BHK",
        "3.5 BHK",
        "4 BHK",
        "4.5 BHK",
        "5 BHK",
        "5+ BHK",
    ];

    const amenities = [
        "Lift",
        "CCTV",
        "Gym",
        "Garden",
        "Kids Area",
        "Sports",
        "Swimming Pool",
        "Intercom",
        "Gated Community",
        "Club House",
        "Community Hall",
        "Regular Water Supply",
        "Power Backup",
        "Pet Allowed",
    ];
    // Toggle Selection
    const toggleSelection = (item, selectedList, setSelectedList) => {
        setSelectedList(
            selectedList.includes(item)
                ? selectedList.filter((i) => i !== item)
                : [...selectedList, item]
        );
    };


    const handleSubmit = async () => {

        const formData = new FormData();
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        const projectSizeFormatted = projectsize.replace(/,/g, '');
        formData.append("proptype", propertyType);
        formData.append("project_status", SelectedStatus?.value || SelectedStatus);
        formData.append("bpn", building);
        formData.append("builder", SelectedBuilder?.value || SelectedBuilder);
        formData.append("city", "Chennai");
        formData.append("pincode", selectedPincode);
        formData.append("pinlocality", selectedLocality);
        formData.append("bhkType", bhkTypes.join(","));
        formData.append("minprice", minprice);
        formData.append("maxprice", maxprice);
        formData.append('projectsize', projectSizeFormatted);
        // formData.append("projectsize", projectsize?.value || projectsize);
        formData.append("minUnitSize", minUnitSize);
        formData.append("maxUnitSize", maxUnitSize);
        formData.append("pricePerSqFt", pricePerSqFt);
        formData.append("totalfloor", totalFloors);
        formData.append("reraNumber", reraNumber);
        formData.append("amenities", selectedAmenities.join(","));
        formData.append("features", features);
        formData.append("locationAdvantages", locationAdvantages);
        formData.append("description", description);
        formData.append("propery_type", propertyType1);
        formData.append("buitupareasq", builtUpArea);
        formData.append("carpetarea", carpetArea);
        formData.append("Buildingdetails", BuildingDetails);
        formData.append("addressaddlocality", Address);
        formData.append("latitude", position[0]);
        formData.append("longitude", position[1]);

        formData.append("addmapp", paraaddress);
        formData.append("agent_name", agent_name);
        formData.append("agent_id", agent_id);
        formData.append("fdt", new Date().toISOString());
        formData.append("status", "a");
        vouchers.forEach((voucher) => formData.append('vouchers', voucher));
        images.forEach((image) => formData.append(`images`, image));
        videos.forEach((video) => formData.append(`videos`, video));

        console.log("Latitude:", position[0]);
        console.log("Longitude:", position[1]);

        console.log("vouchers", vouchers); // Should be File or Blob[]
        vouchers.forEach((voucher) => {
            if (!voucher) console.warn("Empty voucher detected");
            formData.append('vouchers', voucher);
        });


        // Add floor plans
        floorPlans.forEach((floor, index) => {
            formData.append("floorplans", floor.image);
            formData.append(`floorPlans[${index}][unitType]`, floor.unitType);
            formData.append(`floorPlans[${index}][toilet]`, floor.toilet);
            formData.append(`floorPlans[${index}][carpetArea]`, floor.carpetArea);
        });


        const floorPlanData = floorPlans.map(fp => ({
            unitType: fp.unitType,
            carpetArea: fp.carpetArea,
            unitSize: fp.unitSize,
            toilet: fp.toilet
        }));
        formData.append('floorPlanData', JSON.stringify(floorPlanData));



        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        try {
            const response = await axios.post("/add-newproject", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log(response.data);
            alert("Property added successfully");
            navigate('/listings')
        }
        catch (error) {
            console.error("Error submitting form:", error);
  console.error("Error submitting form:", error.response?.data || error.message);
  alert("Failed to add property. Please try again.");
            alert("Failed to add property. Please try again.");
        }
    };



    const [selectedBHK, setSelectedBHK] = useState(""); // BHK type (1 BHK, 2 BHK, etc.)
    const [floorDetails, setFloorDetails] = useState({
        "1 BHK": [],
        "2 BHK": [],
        "3 BHK": [],
        "4 BHK": [],
    });

    const [floorData, setFloorData] = useState({
        builtUpArea: '',
        priceRange: { min: '', max: '' },
        status: '',
        ageOfProperty: '',
        bathroom: '',
        balcony: '',
        preferredTenantType: '',
        petFriendly: '',
        facilitiesImages: [],
        kitchenImages: [],
        bedImages: [],
        bathroomImages: [],
        livingRoomImages: [],
        commonImages: []
    });


    const handleBhkChange = (e) => {
        const value = e.target.value;
        setBhkTypes((prev) =>
            prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
        );
    };

    const handleFloorDataChange = (e) => {
        const { name, value } = e.target;
        setFloorData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    return (
        <div>

            <Dashboard />
            <div className="postprop" >

                {/* Sidebar */}
                <div className="sidebar">
                    <h2>Post your property</h2>
                    <p>Welcome! &nbsp; {agent_name} || {agent_id}</p>
                    <p>ReSell or rent your property</p>

                    <div className="timeline">
                        {steps.map((step) => (
                            <div key={step.id} className={`step ${step.id < currentStep ? "complete" : step.id === currentStep ? "active" : ""}`}>
                                <div className="circle">{step.id < currentStep ? "✓" : step.id}</div>
                                <div className="label">
                                    <p>{step.label}</p>
                                    <span>{step.id < currentStep ? "Completed" : step.id === currentStep ? "In progress" : "Pending"}</span>
                                </div>
                            </div>
                        ))}

                    </div>
                    <span>need help: call +91 9585973683</span>
                </div>

                {/* Add PG/Co-living Properties */}
                <div className="form-section">
                    <div className="form-container ">

                        {currentStep === 1 && (
                            <div>
                                <h2 className="text-xl font-semibold mb-4"><u>Add NewProjects </u></h2>

                                {/* Property Type */}
                                <div className="mb-4">
                                    <p className="mb-2 font-medium">Property Type *</p>
                                    <div className="button-group">
                                        <button
                                            className={`button ${propertyType === "Residential" ? "selected" : ""
                                                }`}
                                            onClick={() => {
                                                setPropertyType("Residential");
                                                setErrors({ ...errors, propertyType: "" });
                                            }}
                                            required
                                        >
                                            Residential
                                        </button>
                                        <button
                                            className={`button ${propertyType === "Commercial" ? "selected" : ""
                                                }`}
                                            onClick={() => {
                                                setPropertyType("Commercial");
                                                setErrors({ ...errors, propertyType: "" });
                                            }}
                                            required
                                        >
                                            Commercial
                                        </button>
                                    </div>
                                    {errors.propertyType && (
                                        <span
                                            style={{ color: "red", fontSize: "0.8rem" }}
                                            className="text-sm"
                                        >
                                            {errors.propertyType}
                                        </span>
                                    )}
                                </div>
                                {/* Unit Status */}
                                <div>
                                    <label className="block mb-2 font-medium">Status *</label>
                                    <Select
                                        options={statusOptions}
                                        value={SelectedStatus}
                                        onChange={(selected) => setSelectedStatus(selected)}
                                        placeholder="Select or type Status"
                                        className='react-select'
                                        isClearable
                                    />
                                </div>

				<div className="mb-4" >
                                    <label className='block mb-2 font-medium'>Property Status *</label>
                                    <input
                                        type="text"
                                        value={selectedPincode}
                                        onChange={(e) => {
                                            setSelectedPincode(e.target.value);
                                            setErrors({ ...errors, selectedLocality: '' });
                                        }}
                                        className="w-full border p-2 rounded-lg"
                                        placeholder="Sold out, Ready to move.."
                                        required
                                    />
                                </div>

                                {/* Builder */}
                                <div>
                                    <label className="block mb-2 font-medium">Builder</label>
                                    <Select
                                        options={builderOptions}
                                        value={SelectedBuilder}
                                        onChange={(selected) => setSelectedBuilder(selected)}
                                        placeholder="Select or type builder"
                                        className='react-select'
                                        isClearable
                                    />
                                </div>


                                {/* Enter city */}
                                <div className="mb-4">
                                    <label className='block mb-2 font-medium'>Enter City *</label>
                                    <input
                                        type="text"
                                        value={city}
                                        onChange={(e) => {
                                            setCity(e.target.value);
                                            setErrors({ ...errors, city: '' }); // Clear error on change
                                        }}
                                        className={`w-full border p-2 rounded-lg ${errors.city ? 'border-red-500' : ''}`} // Added conditional border
                                        placeholder="Enter City"
                                        required
                                    />
                                    {errors.city && (
                                        <span style={{ color: 'red', fontSize: '0.8rem' }}
                                            className="text-sm"> {/* Adjusted error span */}
                                            {errors.city}
                                        </span>
                                    )}
                                </div>

                                {/* Building Details */}
                                <div className="mb-4" >
                                    <label className='block mb-2 font-medium'>Building Name *</label>
                                    <input
                                        type="text"
                                        value={building}
                                        onChange={(e) => {
                                            setBuilding(e.target.value);
                                            setErrors({ ...errors, building: '' });
                                        }}
                                        className="w-full border p-2 rounded-lg"
                                        placeholder="Building/Project/Society"
                                        required
                                    />
                                </div>

                                <div className="mb-4" >
                                    <label className='block mb-2 font-medium'>Locality *</label>
                                    <input
                                        type="text"
                                        value={selectedLocality}
                                        onChange={(e) => {
                                            setSelectedLocality(e.target.value);
                                            setErrors({ ...errors, selectedLocality: '' });
                                        }}
                                        className="w-full border p-2 rounded-lg"
                                        placeholder="Building/Project/Society"
                                        required
                                    />
                                </div>

                                

                                {/* BHK Range */}

                                <div className="bhk-wrapper">
                                    <label className="bhk-label">BHK Range *<span className='example'>(Select Any Two ...)</span></label>
                                    <div className="bhk-options">
                                        {bhkOptions.map((status) => (
                                            <label
                                                key={status}
                                                className={`bhk-option ${bhkTypes.includes(status) ? "active" : ""}`}
                                            >
                                                <input
                                                    type="checkbox"
                                                    value={status}
                                                    checked={bhkTypes.includes(status)}
                                                    onChange={handleBhkChange}
                                                    className="hidden-checkbox"
                                                />
                                                {status}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Price Range */}
                                <div>
                                    <label>Price Range *</label>
                                    <div className='flex'>
                                        <input
                                            type="text"
                                            name="min"
                                            value={minprice}
                                            onChange={(e) => { setMinprice(e.target.value); setErrors({ ...errors, minprice: '' }) }}
                                            placeholder="Min Price"

                                        />
                                        <input
                                            type="text"
                                            name="max"
                                            value={maxprice}
                                            onChange={(e) => { setMaxprice(e.target.value); setErrors({ ...errors, maxprice: '' }) }}
                                            placeholder="Max Price"
                                        />
                                    </div>
                                </div>
                                <label className="block mb-2 font-medium">Property Type *</label>
                                <div className=" button-group">
                                    {propertyTypes.map((type) => (
                                        <button
                                            key={type}
                                            type="button"
                                            className={`grid-item ${propertyType1 === type ? "active" : "bg-gray-200"
                                                }`}
                                            onClick={() => {
                                                setPropertyType1(type);
                                                setErrors({ ...errors, propertyType1: '' });
                                            }}
                                            required
                                        >
                                            {type}
                                        </button>
                                    ))}

                                </div>
                                {errors.propertyType1 && (
                                    <span style={{ color: 'red', fontSize: '0.8rem' }}
                                        className="text-sm">{errors.propertyType1}
                                    </span>
                                )}
                                {/* projects size */}
                                <div>
                                    <label>Project size (sq. ft.) *</label>
                                    <input
                                        type="text"
                                        name="builtUpArea"
                                        value={projectsize}
                                        onChange={(e) => setProjectSize(e.target.value)}
                                        placeholder="Total project size"
                                    />
                                </div>


                                {/* Price Range */}
                                <div>
                                    <label>Unit Size Range *</label>
                                    <div className='flex'>
                                        <input
                                            type="text"
                                            name="min"
                                            value={minUnitSize}
                                            onChange={(e) => setMinUnitSize(e.target.value)}
                                            placeholder="start unit size"
                                        />
                                        <input
                                            type="text"
                                            name="max"
                                            value={maxUnitSize}
                                            onChange={(e) => setMaxUnitSize(e.target.value)}
                                            placeholder="End Unit Size"
                                        />
                                    </div>
                                </div>

                                {/* price per Sq.ft */}
                                <div>
                                    <label>Price per (sq. ft.) *</label>
                                    <input
                                        type="text"
                                        name="builtUpArea"
                                        value={pricePerSqFt}
                                        onChange={(e) => setPricePerSqFt(e.target.value)}
                                        placeholder="Enter price per sq. ft."
                                    />
                                </div>
                                {/* Total FLOOR*/}
                                <div>
                                    <label>Total Floors *</label>
                                    <input
                                        type="text"
                                        name="builtUpArea"
                                        value={totalFloors}
                                        onChange={(e) => setTotalFloors(e.target.value)}
                                        placeholder="Enter total floor"
                                    />
                                </div>
                                {/*Rera Number*/}
                                <div>
                                    <label> Rera Number *</label>
                                    <input
                                        type="text"
                                        name="builtUpArea"
                                        value={reraNumber}
                                        onChange={(e) => setReraNumber(e.target.value)}
                                        placeholder="Enter Rera Number"
                                    />
                                </div>
                                {/* Flat Furnishings */}
                                <h3 className="text-lg font-medium mb-2">Amenites</h3>
                                <div className="button-group mb-4">
                                    {Amenites.map((item) => (
                                        <button
                                            key={item}
                                            className={`grid-item ${selectedAmenities.includes(item) ? "active" : " "
                                                }`}
                                            onClick={() =>
                                                toggleSelection(
                                                    item,
                                                    selectedAmenities,
                                                    setSelectedAmenities
                                                )
                                            }
                                        >
                                            {item}
                                        </button>
                                    ))}
                                </div>


                                {/*Features */}
                                <div>
                                    <label> Features *<span className='example'>(Example:lift,cctv...)</span></label>
                                    <input
                                        type="text"
                                        name="Features"
                                        value={features}
                                        onChange={(e) => setFeatures(e.target.value)}
                                        className="w-full p-2 border rounded-lg"
                                        placeholder="Enter Features"

                                    />
                                </div>
                                {/*Location Advantage */}
                                <div>
                                    <label> location Advantages <span className='example'>(Example:2 km away is the American International School,...)</span></label>
                                    <textarea
                                        type="text"
                                        name="locationAdvantages"
                                        value={locationAdvantages}
                                        onChange={(e) => setLocationAdvantages(e.target.value)}
                                        className="w-full p-2 border rounded-lg"
                                        placeholder="Enter location advantages"
                                        rows={4}
                                    />
                                </div>
                                {/*Enter Descriptiom */}
                                <div className="mb-4" >
                                    <label className="block mb-2 font-medium">Description</label>
                                    <textarea
                                        type="text"
                                        value={description}
                                        onChange={(e) => {
                                            setDescription(e.target.value);
                                        }}
                                        className="w-full p-2 border rounded-lg"
                                        placeholder="Enter Description."
                                        required
                                        rows={4}
                                    />

                                </div>
                                {/* Voucher Upload */}
                                <div className="mb-4">
                                    <label className="block mb-2 font-medium">Upload Voucher</label>
                                    <input
                                        type="file"
                                        accept="image/*, application/pdf"
                                        multiple
                                        onChange={handleVoucherUpload}
                                        className="w-full p-2 border rounded-lg"
                                    />
                                    <div className="preview-container">
                                        {vouchers.map((voucher, index) => {
                                            let voucherUrl = "";
                                            if (voucher instanceof File) {
                                                voucherUrl = URL.createObjectURL(voucher);
                                            } else {
                                                voucherUrl = voucher;
                                            }

                                            return (
                                                <div key={index} className="preview-item">
                                                    {/* If the voucher is a PDF, display a link or an icon */}
                                                    {voucher instanceof File && voucher.type === 'application/pdf' ? (
                                                        <a href={voucherUrl} target="_blank" rel="noopener noreferrer" className="voucher-link">
                                                            View Voucher
                                                        </a>
                                                    ) : (
                                                        <img src={voucherUrl} alt="Voucher Preview" className="voucher-preview" />
                                                    )}
                                                    <button
                                                        onClick={() => removeVoucher(index)} // Remove the voucher
                                                        className="remove-btn"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div style={{ padding: '0px' }}>

                                    <div className='floorplan-container'>
                                        <h4>Floor Plan</h4>
                                        {floorPlans.map((floor, index) => (
                                            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', flexDirection: 'column' }}>
                                                <div className='floor-flex'>
                                                    <input
                                                        type="file"
                                                        onChange={(e) => handleChange1(index, 'image', e.target.files[0])}
                                                    />

                                                </div><div className='floor-flex'>
                                                    <input
                                                        type="text"
                                                        placeholder="unit size"
                                                        value={floor.unitSize}
                                                        onChange={(e) => handleChange1(index, 'unitSize', e.target.value)}

                                                    />
                                                    {propertyType1 !== "Plot" && (
                                                        <>
                                                            <select
                                                                value={floor.unitType}
                                                                onChange={(e) => handleChange1(index, 'unitType', e.target.value)}
                                                            >
                                                                {bhkOptions.map((bhk, index) => (
                                                                    <div key={index}>
                                                                        <option key={index} value={bhk}>{bhk}</option>
                                                                    </div>
                                                                ))}

                                                                {/* Add more options as needed */}
                                                            </select>
                                                            <input
                                                                type="text"
                                                                placeholder="Toilet"
                                                                value={floor.toilet}
                                                                onChange={(e) => handleChange1(index, 'toilet', e.target.value)}

                                                            />

                                                            <input
                                                                type="text"
                                                                placeholder="carpet area"
                                                                value={floor.carpetArea}
                                                                onChange={(e) => handleChange1(index, 'carpetArea', e.target.value)}

                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))}

                                        <button
                                            onClick={addFloor}
                                            style={{
                                                marginTop: '10px',
                                                backgroundColor: '#4285f4',
                                                color: 'white',
                                                border: 'none',
                                                padding: '10px 20px',
                                                borderRadius: '5px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Add Floor
                                        </button>
                                    </div>
                                </div>

                            </div>
                        )}

                        {/* -------------------------------------------------------Add Address---------------------------------------------------------- */}


                        {currentStep === 2 && (
                            <div>
                                <h2 className="text-lg font-semibold">Add Address</h2>
                                <p className="text-gray-600">Paste Google Maps Embed Link</p>
                                
                                <input
                                    type="text"
                                    placeholder="Paste Google Maps embed link"
                                    value={url}
                                    onChange={(e) => setUrl(e.target.value)}
                                    className="w-full border rounded-lg p-2 my-2"
                                />

                                <h3 className="text-md font-medium mt-4">Map Preview</h3>
                                <p className="text-sm text-gray-500">
                                    Paste the full <strong>embed link</strong> from Google Maps (not a short link). <br />
                                    <strong>How to get it:</strong> Go to Maps → Share → Embed a map → Copy HTML → Extract only the <code>src</code> URL.
                                </p>

                                <div className="mapcontainer">
                                    {url.includes("https://www.google.com/maps/embed") ? (
                                        <iframe
                                            title="Map Preview"
                                            width="100%"
                                            height="400"
                                            style={{ border: "0", borderRadius: "8px", marginTop: "10px" }}
                                            src={url}
                                            allowFullScreen
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                        ></iframe>
                                    ) : (
                                        <p className="text-red-500">Valid embed link not found</p>
                                    )}
                                </div>

                                {Address && (
                                    <p className="mt-2 text-gray-700">
                                        <strong>Coordinates:</strong> {Address}
                                    </p>
                                )}   

                                {/* <button onClick={handleSubmit} className="next-button">
             Post Property
           </button> */}  {/* Image Upload Section */}
                                <div className="mb-4">
                                    <label className="block mb-2 font-medium">Upload Images</label>
                                    <input type="file" accept="image/*" multiple onChange={handleImageUpload} className="w-full p-2 border rounded-lg" />


                                    <div className="preview-container">
                                        {images.map((image, index) => {
                                            let imageUrl = "";

                                            if (typeof image === "string") {
                                                // Direct URL from DB
                                                imageUrl = image;
                                            } else if (image instanceof File) {
                                                // File uploaded by user
                                                imageUrl = URL.createObjectURL(image);
                                            } else {
                                                console.error("Invalid file data:", image);
                                                return null;
                                            }

                                            return (
                                                <div key={index} className="preview-item">
                                                    <img src={imageUrl} alt="Uploaded" />
                                                    <button
                                                        onClick={() => removeImage(index)}
                                                        className="remove-btn"
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                {/* Video Upload Section */}
                                <div className="mb-4">
                                    <label className="block mb-2 font-medium">Upload Videos</label>
                                    <input type="file" accept="video/*" multiple onChange={handleVideoUpload} className="w-full p-2 border rounded-lg" />
                                    <div className="grid grid-cols-2 gap-2 mt-2">
                                        {videos.map((video, index) => (
                                            <video key={index} controls className="w-full h-32 rounded-lg">
                                                <source src={URL.createObjectURL(video)} type="video/mp4" />
                                            </video>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}


                        <div className="button-group">
                            {currentStep > 1 && (
                                <button onClick={handlePrevStep} className="button prev">
                                    Back
                                </button>
                            )}
                            {currentStep < steps.length ? (
                                <button
                                    onClick={() => {
                                        if (handleNextStep()) {
                                            handleNextStep();
                                            handleNext();
                                        } else {
                                            toast.error("Please fill all required fields", {
                                                position: "top-center",
                                                autoClose: 3000,
                                            });
                                        }
                                    }}
                                    className="button next"
                                >
                                    Next
                                </button>
                            ) : (
                                <button onClick={handleSubmit} className="button submit">
                                    Submit
                                </button>
                            )}
                        </div>
                        {/* ADD THIS BELOW */}
                        <ToastContainer
                            position="top-center"
                            autoClose={3000}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="colored"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
